import React from "react"
import { Helmet } from "react-helmet"
import { APP_ID } from 'components/dashboard/constants'

const MetaAppleApp = ({ icc, page, refreshToken }) => {
  return (
    <Helmet>
      <meta
        name='apple-itunes-app'
        content={`app-id=${APP_ID}, app-argument="icc=${icc || ''}&page=${page || ''}&refreshToken=${refreshToken || ''}"`}
      />
    </Helmet>
  )
}

export default MetaAppleApp



// WEBPACK FOOTER //
// ./app/javascript/components/shared/meta_apple_app.js